/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CheckPatientPhoneParams,
  CreatePatientParams,
  GetPatientRxSummaryParams,
  GetPatientsParams,
  HTTPValidationError,
  PagePatientManyRead,
  PagePatientRxSummary,
  Patient,
  PatientCreate,
  PatientCreateCheck,
  PatientHistoryEvent,
  PatientPhoneCheckResult,
  PatientRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new patient.
 * @summary Create Patient
 */
export const createPatient = (
  patientCreate: PatientCreate,
  params: CreatePatientParams,
  signal?: AbortSignal,
) => {
  return customInstance<Patient>({
    url: `/api/patient/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: patientCreate,
    params,
    signal,
  });
};

export const getCreatePatientMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPatient>>,
    TError,
    { data: PatientCreate; params: CreatePatientParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPatient>>,
  TError,
  { data: PatientCreate; params: CreatePatientParams },
  TContext
> => {
  const mutationKey = ["createPatient"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPatient>>,
    { data: PatientCreate; params: CreatePatientParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return createPatient(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPatient>>
>;
export type CreatePatientMutationBody = PatientCreate;
export type CreatePatientMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Patient
 */
export const useCreatePatient = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPatient>>,
      TError,
      { data: PatientCreate; params: CreatePatientParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPatient>>,
  TError,
  { data: PatientCreate; params: CreatePatientParams },
  TContext
> => {
  const mutationOptions = getCreatePatientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many patients.

Results are paginated.
 * @summary Get Patients
 */
export const getPatients = (
  params?: GetPatientsParams,
  signal?: AbortSignal,
) => {
  return customInstance<PagePatientManyRead>({
    url: `/api/patient/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPatientsInfiniteQueryKey = (params?: GetPatientsParams) => {
  return ["infinite", "api", "patient", ...(params ? [params] : [])] as const;
};

export const getGetPatientsQueryKey = (params?: GetPatientsParams) => {
  return ["api", "patient", ...(params ? [params] : [])] as const;
};

export const getGetPatientsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPatients>>,
    GetPatientsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPatients>>,
        TError,
        TData,
        QueryKey,
        GetPatientsParams["page"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatientsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatients>>,
    QueryKey,
    GetPatientsParams["page"]
  > = ({ signal, pageParam }) =>
    getPatients({ ...params, page: pageParam || params?.["page"] }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPatients>>,
    TError,
    TData,
    QueryKey,
    GetPatientsParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatients>>
>;
export type GetPatientsInfiniteQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetPatientsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPatients>>,
    GetPatientsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetPatientsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPatients>>,
        TError,
        TData,
        QueryKey,
        GetPatientsParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPatients>>,
    GetPatientsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPatients>>,
        TError,
        TData,
        QueryKey,
        GetPatientsParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPatients>>,
    GetPatientsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPatients>>,
        TError,
        TData,
        QueryKey,
        GetPatientsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patients
 */

export function useGetPatientsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPatients>>,
    GetPatientsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPatients>>,
        TError,
        TData,
        QueryKey,
        GetPatientsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPatientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatients>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatients>>> = ({
    signal,
  }) => getPatients(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatients>>
>;
export type GetPatientsQueryError = ErrorType<void | HTTPValidationError>;

export function useGetPatients<
  TData = Awaited<ReturnType<typeof getPatients>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetPatientsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatients<
  TData = Awaited<ReturnType<typeof getPatients>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatients<
  TData = Awaited<ReturnType<typeof getPatients>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patients
 */

export function useGetPatients<
  TData = Awaited<ReturnType<typeof getPatients>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to check for duplicate patients.
 * @summary Check Create Patient
 */
export const checkCreatePatient = (
  patientCreate: PatientCreate,
  signal?: AbortSignal,
) => {
  return customInstance<PatientCreateCheck>({
    url: `/api/patient/check`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: patientCreate,
    signal,
  });
};

export const getCheckCreatePatientMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkCreatePatient>>,
    TError,
    { data: PatientCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkCreatePatient>>,
  TError,
  { data: PatientCreate },
  TContext
> => {
  const mutationKey = ["checkCreatePatient"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkCreatePatient>>,
    { data: PatientCreate }
  > = (props) => {
    const { data } = props ?? {};

    return checkCreatePatient(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckCreatePatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkCreatePatient>>
>;
export type CheckCreatePatientMutationBody = PatientCreate;
export type CheckCreatePatientMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Check Create Patient
 */
export const useCheckCreatePatient = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkCreatePatient>>,
      TError,
      { data: PatientCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkCreatePatient>>,
  TError,
  { data: PatientCreate },
  TContext
> => {
  const mutationOptions = getCheckCreatePatientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to check if a phone number can receive text messages.
 * @summary Check Patient Phone
 */
export const checkPatientPhone = (
  params: CheckPatientPhoneParams,
  signal?: AbortSignal,
) => {
  return customInstance<PatientPhoneCheckResult>({
    url: `/api/patient/phone-check`,
    method: "GET",
    params,
    signal,
  });
};

export const getCheckPatientPhoneQueryKey = (
  params?: CheckPatientPhoneParams,
) => {
  return [
    "api",
    "patient",
    "phone-check",
    ...(params ? [params] : []),
  ] as const;
};

export const getCheckPatientPhoneQueryOptions = <
  TData = Awaited<ReturnType<typeof checkPatientPhone>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: CheckPatientPhoneParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkPatientPhone>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCheckPatientPhoneQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkPatientPhone>>
  > = ({ signal }) => checkPatientPhone(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof checkPatientPhone>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CheckPatientPhoneQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkPatientPhone>>
>;
export type CheckPatientPhoneQueryError = ErrorType<void | HTTPValidationError>;

export function useCheckPatientPhone<
  TData = Awaited<ReturnType<typeof checkPatientPhone>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: CheckPatientPhoneParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkPatientPhone>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkPatientPhone>>,
          TError,
          Awaited<ReturnType<typeof checkPatientPhone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckPatientPhone<
  TData = Awaited<ReturnType<typeof checkPatientPhone>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: CheckPatientPhoneParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkPatientPhone>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkPatientPhone>>,
          TError,
          Awaited<ReturnType<typeof checkPatientPhone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckPatientPhone<
  TData = Awaited<ReturnType<typeof checkPatientPhone>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: CheckPatientPhoneParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkPatientPhone>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Check Patient Phone
 */

export function useCheckPatientPhone<
  TData = Awaited<ReturnType<typeof checkPatientPhone>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: CheckPatientPhoneParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkPatientPhone>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCheckPatientPhoneQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get patient prescription (Rx) summaries.
 * @summary Get Patient Rx Summary
 */
export const getPatientRxSummary = (
  params?: GetPatientRxSummaryParams,
  signal?: AbortSignal,
) => {
  return customInstance<PagePatientRxSummary>({
    url: `/api/patient/get_patient_rx_summary`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPatientRxSummaryQueryKey = (
  params?: GetPatientRxSummaryParams,
) => {
  return [
    "api",
    "patient",
    "get_patient_rx_summary",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPatientRxSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientRxSummary>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientRxSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientRxSummary>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatientRxSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientRxSummary>>
  > = ({ signal }) => getPatientRxSummary(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientRxSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientRxSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientRxSummary>>
>;
export type GetPatientRxSummaryQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetPatientRxSummary<
  TData = Awaited<ReturnType<typeof getPatientRxSummary>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetPatientRxSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientRxSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientRxSummary>>,
          TError,
          Awaited<ReturnType<typeof getPatientRxSummary>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientRxSummary<
  TData = Awaited<ReturnType<typeof getPatientRxSummary>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientRxSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientRxSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientRxSummary>>,
          TError,
          Awaited<ReturnType<typeof getPatientRxSummary>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientRxSummary<
  TData = Awaited<ReturnType<typeof getPatientRxSummary>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientRxSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientRxSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient Rx Summary
 */

export function useGetPatientRxSummary<
  TData = Awaited<ReturnType<typeof getPatientRxSummary>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPatientRxSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientRxSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientRxSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an patient by ID.
 * @summary Get Patient
 */
export const getPatient = (patientId: string, signal?: AbortSignal) => {
  return customInstance<PatientRead>({
    url: `/api/patient/${patientId}`,
    method: "GET",
    signal,
  });
};

export const getGetPatientQueryKey = (patientId?: string) => {
  return ["api", "patient", patientId] as const;
};

export const getGetPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatient>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatient>>> = ({
    signal,
  }) => getPatient(patientId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!patientId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatient>>
>;
export type GetPatientQueryError = ErrorType<void | HTTPValidationError>;

export function useGetPatient<
  TData = Awaited<ReturnType<typeof getPatient>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  patientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatient>>,
          TError,
          Awaited<ReturnType<typeof getPatient>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatient<
  TData = Awaited<ReturnType<typeof getPatient>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatient>>,
          TError,
          Awaited<ReturnType<typeof getPatient>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatient<
  TData = Awaited<ReturnType<typeof getPatient>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient
 */

export function useGetPatient<
  TData = Awaited<ReturnType<typeof getPatient>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientQueryOptions(patientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an patient by ID.
 * @summary Update Patient
 */
export const updatePatient = (
  patientId: string,
  patientCreate: PatientCreate,
) => {
  return customInstance<Patient>({
    url: `/api/patient/${patientId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: patientCreate,
  });
};

export const getUpdatePatientMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePatient>>,
    TError,
    { patientId: string; data: PatientCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePatient>>,
  TError,
  { patientId: string; data: PatientCreate },
  TContext
> => {
  const mutationKey = ["updatePatient"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePatient>>,
    { patientId: string; data: PatientCreate }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return updatePatient(patientId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePatient>>
>;
export type UpdatePatientMutationBody = PatientCreate;
export type UpdatePatientMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Patient
 */
export const useUpdatePatient = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePatient>>,
      TError,
      { patientId: string; data: PatientCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePatient>>,
  TError,
  { patientId: string; data: PatientCreate },
  TContext
> => {
  const mutationOptions = getUpdatePatientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete an patient by ID.
 * @summary Delete Patient
 */
export const deletePatient = (patientId: string) => {
  return customInstance<unknown>({
    url: `/api/patient/${patientId}`,
    method: "DELETE",
  });
};

export const getDeletePatientMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePatient>>,
    TError,
    { patientId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePatient>>,
  TError,
  { patientId: string },
  TContext
> => {
  const mutationKey = ["deletePatient"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePatient>>,
    { patientId: string }
  > = (props) => {
    const { patientId } = props ?? {};

    return deletePatient(patientId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePatient>>
>;

export type DeletePatientMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Patient
 */
export const useDeletePatient = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePatient>>,
      TError,
      { patientId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deletePatient>>,
  TError,
  { patientId: string },
  TContext
> => {
  const mutationOptions = getDeletePatientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get an patient's history by ID.
 * @summary Get Patient History
 */
export const getPatientHistory = (patientId: string, signal?: AbortSignal) => {
  return customInstance<PatientHistoryEvent[]>({
    url: `/api/patient/${patientId}/history`,
    method: "GET",
    signal,
  });
};

export const getGetPatientHistoryQueryKey = (patientId?: string) => {
  return ["api", "patient", patientId, "history"] as const;
};

export const getGetPatientHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientHistory>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientHistory>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPatientHistoryQueryKey(patientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPatientHistory>>
  > = ({ signal }) => getPatientHistory(patientId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!patientId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientHistory>>
>;
export type GetPatientHistoryQueryError = ErrorType<void | HTTPValidationError>;

export function useGetPatientHistory<
  TData = Awaited<ReturnType<typeof getPatientHistory>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  patientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientHistory>>,
          TError,
          Awaited<ReturnType<typeof getPatientHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientHistory<
  TData = Awaited<ReturnType<typeof getPatientHistory>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientHistory>>,
          TError,
          Awaited<ReturnType<typeof getPatientHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPatientHistory<
  TData = Awaited<ReturnType<typeof getPatientHistory>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Patient History
 */

export function useGetPatientHistory<
  TData = Awaited<ReturnType<typeof getPatientHistory>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPatientHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPatientHistoryQueryOptions(patientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
